import ActionType from 'store/_utils/classes/ActionType';

import type IActionType from 'store/_utils/interfaces/IActionType';

class ClickConversionTypes {
  static search: IActionType = new ActionType('CLICK_CONVERSION/SEARCH');
  static graphics: IActionType = new ActionType('CLICK_CONVERSION/GRAPHICS');
  static graphicsSales: IActionType = new ActionType('CLICK_CONVERSION/GRAPHIC_SALES');
  static utmsGraphic: IActionType = new ActionType('CLICK_CONVERSION/GRAPHICS_UTMS');
  static topPaymentMethods: IActionType = new ActionType('CLICK_CONVERSION/TOP_PAYMENT_METHODS');
  static topAffiliates: IActionType = new ActionType('CLICK_CONVERSION/TOP_AFFILIATES');
  static listUtms: IActionType = new ActionType('CLICK_CONVERSION/LIST_UTM');
  static listCampaigns: IActionType = new ActionType('CLICK_CONVERSION/LIST_CAMPAIGN');
}

export default ClickConversionTypes;
